<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/setup/fee-master" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.CreateFeeMaster") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card title card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.FeeMasterCode')"
              >
                <vs-input
                  :label="$t('setup.label.FeeMasterCode')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.feeCode"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.FeeMasterDescription')"
              >
                <vs-input
                  :label="$t('setup.label.FeeMasterDescription')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="Reports.feeDescription"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-6 font-semibold"
                  >{{ $t("setup.label.FeeMasterTransactionType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.FeeMasterTransactionType')"
                >
                  <v-select
                    label="mCodeValue"
                    :options="ReportsData.transactionTypeDatas"
                    v-model="Reports.transactionType"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mt-6 mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label mt-6 font-semibold"
                  >{{ $t("setup.label.ChargeCode") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ChargeCode')"
                >
                  <v-select
                    label="chargeCode"
                    :options="ReportsData.chargeDatas"
                    v-model="Reports.chargeCode"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mt-6 mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <h4>
                {{ $t("setup.label.VariablePricing") }}
              </h4>
            </div>
          </div>
          <div class="vx-row mt-4">
            <div class="vx-col w-1/4">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.Regions")
                }}</small>
                <v-select
                  label="regionName"
                  :options="ReportsData.regionDatas"
                  v-model="Reports.regionName"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <!-- <template v-slot:option="option">{{ option.item }}</template> -->
                </v-select>
              </div>
            </div>
            <div class="vx-col w-1/4">
              <vs-input
                :label="$t('setup.label.Amount')"
                class="w-full mb-2 font-semibold starlabel"
                v-model="Reports.amount"
                type="number"
              />
            </div>
            <div class="vx-col md:w-1/4 mt-4" style="margin: 0.5rem 0">
              <vs-button
                @click="addParameter"
                icon-pack="feather"
                :disabled="!Reports.regionName || !Reports.amount"
                icon="icon-plus"
                title="add"
                color="success"
                svgClasses="w-5 h-5
              hover:text-primary stroke-current cursor"
              >
              </vs-button>
            </div>
          </div>
          <div class="vx-row mt-6">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="block overflow-x-auto">
                <table class="w-full">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Regions") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.Price") }}</b>
                    </td>
                    <td class="tHeadCenter">
                      <b>{{ $t("setup.label.Action") }}</b>
                    </td>
                  </tr>
                  <tr
                    v-for="(Reports, index) in Reports.regionDatas"
                    :key="index"
                  >
                    <td>{{ Reports.regionName }}</td>
                    <td>{{ Reports.amount }}</td>

                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <button
                          @click="removeItem(index)"
                          class="bGNone border-none view_editTable_btn"
                        >
                          <feather-icon
                            icon="TrashIcon"
                            :title="$t('setup.label.Delete')"
                            svgClasses="w-5 h-5 text-danger stroke-current cursor"
                            class="icon_row"
                          />
                        </button>
                      </div>
                    </vs-td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createFeemaster"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const ReportsEmptyObj = {
  chargeCode: "",
  defaultFeeAmount: 0,
  feeCode: "",
  feeDescription: "",
  locale: "en",
  regionPrices: [],
  transactionType: "",
  regionDatas: [],
};

export default {
  data() {
    return {
      Reports: ReportsEmptyObj,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      ReportsData: (state) => state.feeMaster.FeeMasterTemplate,
    }),
  },
  methods: {
    removeItem(i) {
      this.Reports.regionDatas.splice(i, 1);
    },
    addParameter() {
      try {
        let crateParameter = {
          regionName: this.Reports.regionName.regionName,
          regionId: this.Reports.regionName.id,
          amount: this.Reports.amount,
        };
        if (this.Reports.regionName !== "") {
          this.Reports.regionDatas = [
            ...this.Reports.regionDatas,
            crateParameter,
          ];
          this.Reports.regionName = "";
          this.Reports.amount = "";
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  async createFeemaster() {
  const isValid = await this.$refs.observer.validate();
  if (!isValid) return;

  if (!this.Reports.regionDatas.length) {
    this.warningPopup = true;
    this.warningText = "Please add region data";
    return;
  }

  try {
    const payload = {
      feeCode: this.Reports.feeCode,
      feeDescription: this.Reports.feeDescription,
      transactionType: this.Reports.transactionType.mCodeValue,
      chargeCode: this.Reports.chargeCode.chargeCode,
      locale: "en",
      regionPrices: this.Reports.regionDatas.map((region) => ({
        regionId: region.regionId,
        regionName: region.regionName,
        amount: region.amount,
        locale: "en",
      })),
    };

    await this.$store.dispatch("feeMaster/createFeemasterAction", payload);

    this.$swal({
      title: "Success",
      icon: "success",
      text: "Fee Master Created Successfully!",
      type: "success",
    });

    this.$router.push("/setup/fee-master");
    this.resetForm();
  } catch (error) {
    let message = "";

    if (
      error &&
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      message = error.response.data.message;
    } else {
      message = String(error).replace(/^Error:\s*/, "") || "Something went wrong";
    }
    this.$swal({
      title: "Error",
      icon: "error",
      html: `<div style='text-align:center;'>${message}</div>`,
      type: "error",
    });
  }
},

    async getFeemasterTemplate() {
      try {
        await this.$store.dispatch("feeMaster/setFeemasterTemplate", this.id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancel() {
      this.$router.push("/setup/fee-master");
    },

    resetForm() {
      this.Reports = ReportsEmptyObj;
      this.Reports.feeCode = "";
      this.Reports.feeDescription = "";
      this.Reports.transactionType = "";

      this.Reports.regionDatas = [];
      this.Reports.chargeCode = "";
      // this.Reports.regionName = "";
      // this.Reports.amount = "";

      if (this.$refs.observer) {
        this.$refs.observer.reset(); 
      }
    },
  },
  watch: {},
  created() {},
  mounted() {
    this.resetForm();
    this.id = this.$route.params.id;
    this.getFeemasterTemplate();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
